import { motion } from "framer-motion";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Address from "./Address";
import OrderProductList from "./OrderProductList";
import Typography from "@mui/material/Typography";
import { useEffect } from "@wordpress/element";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getInvoice } from "store/vino/invoiceSlice";

const Invoice = () => {
	const dispatch = useDispatch();
	const invoice = useSelector(({ vino }) => vino.invoice.data);
	const { orderId } = useParams();

	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	useEffect(() => {
		dispatch(getInvoice(orderId));
	}, [orderId]);

	if (!invoice) {
		return null;
	}

	const { shippingAddress, billingAddress } = invoice;

	return (
		<div className="flex flex-col flex-auto flex-shrink-0 w-full h-full">
			<div className="flex flex-col flex-1 max-w-xl w-full mx-auto px-8 sm:px-16">
				<motion.div
					className="flex flex-wrap"
					variants={container}
					initial="hidden"
					animate="show"
				>
					<Card
						component={motion.div}
						className="w-full mb-32 rounded-16 shadow"
					>
						<CardContent className="p-88 ">
							<Typography className="text-3xl text-center  mb-38" variant="h6">
								<span className="font-semibold">
									Your Order Placed Successfully !
								</span>
							</Typography>
							<div className="flex justify-between">
								<div className="pt-16">
									<Typography
										className="font-light"
										variant="h6"
										color="textSecondary"
									>
										Order details
									</Typography>
								</div>
							</div>
							<div className="flex flex-shrink-0 items-center justify-between px-24 pt-20 h-64">
								<Address address={shippingAddress} title="Shipping Address" />
								<div className="flex items-center justify-center opacity-75">
									<div className="text-14 font-medium whitespace-nowrap">
										<Address address={billingAddress} title="Billing Address" />
									</div>
								</div>
							</div>
							<div className="pt-32">
								<OrderProductList invoice={invoice} />
							</div>
						</CardContent>
					</Card>
				</motion.div>
			</div>
		</div>
	);
};

export default Invoice;
